import { Flex } from '../../../2022-component-library';
import { Fragment, useState, useEffect, useCallback } from 'react';
import { PatientFacialDetection } from '../../../components';
import { useReceiveMessage } from '../../../context/messageContext';
import Arrow from '../../../assets/img/upwards-arrow.svg';

const ResponsiveLogmarTestPatient = ({ logmarType }) => {
  const messageFromOptician = useReceiveMessage();
  const [logmarData, setLogmarData] = useState({});
  const [testMode, setTestMode] = useState('');
  const [highlightedCharacter, setHighlightedCharacter] = useState('');

  const getBorderStyleAttributes = useCallback(() => {
    return {
      borderWidth: logmarData.size ? logmarData.size / 8 : 0,
      borderStyle: 'solid',
      padding: logmarData.size ? logmarData.size / 3 : 0,
    };
  }, [logmarData?.size]);

  useEffect(() => {
    if (messageFromOptician?.type !== 'highlightLogmarCharacter') return;
    const charToHighlight = messageFromOptician.content?.slice(-1);
    setHighlightedCharacter(charToHighlight);
  }, [messageFromOptician]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'resizeLogmar':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          characters: messageFromOptician.content.logmarCharacters?.split(''),
        });
        break;
      case 'visualAcuityTest':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceFromScreen,
          characters: messageFromOptician.content.logmarCharacters?.split(''),
          methodSelected: messageFromOptician.content.methodSelected,
          testMode: messageFromOptician.content.testMode,
        });
        if (messageFromOptician.content.methodSelected !== 'manual') {
          setTestMode('auto');
        } else {
          setTestMode(messageFromOptician.content.testMode);
        }
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex centered height='100vh' width='100vw'>
      <PatientFacialDetection testMode={testMode} />
      <Flex style={logmarType?.includes('Crowded') ? getBorderStyleAttributes() : null}>
        {logmarData?.characters?.map((char, idx) => {
          return (
            <Fragment key={`logmar-char-${idx}-${char}`}>
              <Flex style={{ position: 'relative' }}>
                <span style={{ fontFamily: 'OpticianSans', fontSize: `${logmarData?.size || 0}px`, whiteSpace: 'pre' }}>{char}</span>
                {highlightedCharacter === char && (
                  <img
                    src={Arrow}
                    alt='arrow highlighting character'
                    style={{
                      height: logmarData?.size || 0,
                      position: 'absolute',
                      top: `${logmarData?.size * (1 + (logmarType === 'Crowded' ? 0.75 : 0.25))}px`,
                      left: '50%',
                      transform: 'translateX(-50%)',
                    }}
                  />
                )}
              </Flex>
            </Fragment>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default ResponsiveLogmarTestPatient;
